<aff-header [showNavigation]="false"></aff-header>

<div class="cookies-policy">
    <div class="c-sub-header mb-md">
        <div class="c-b2b-width text-align-left">
            <h1>Cookie Policy</h1>
        </div>
    </div>
    <div class="c-b2b-width mb-sm">
        <div class="flex align-items-center my-sm">
            <h2 class="mb-no font-weight-bold mr-xs">Device information and Analytical Cookies</h2>
            <mat-slide-toggle
                [checked]="toggleChecked"
                (change)="updateCookieDecision()"
                [attr.data-qa-id]="'toggle-cookies'"
            ></mat-slide-toggle>
        </div>
        <p class="mt-sm mb-sm text-align-justify">
            We use cookies to collect information about the device or browser you are using, and we may use this information to monitor how the site is being used. We also use cookies to help us monitor how the website is performing, allowing us to improve and tailor user experience to the site and identify and fix issues. The cookies recognise when the website is accessed in the same browser session, or from the same device, and helps us to tie events together. A list of cookies we use are mentioned below.
        </p>

        <table class="mb-md">
            <tr>
                <th class="cookie">Cookie</th>
                <th class="name">Name</th>
                <th class="purpose">Purpose</th>
            </tr>
            <tr>
                <td>
                    <p>Microsoft Azure Application Insights Cookies</p>
                </td>
                <td>
                    <p>ai_session<br>ai_user</p>
                </td>
                <td>
                    <p>These cookies are used to help us monitor how the website is performing, allowing us to improve and tailor user experience to the site and identify and fix issues. The cookies recognise when the website is accessed in the same browser session, or from the same device, and helps us to tie events together.</p>
                </td>
            </tr>
            @if (showPendoCookies) {
            <tr [attr.data-qa-id]="'pendo-cookie-row'">
                <td>
                    <p>Pendo</p>
                </td>
                <td>
                    <p>pendo_*<br>pendo.sess.*<br>pendo.env<br>pendo_identity</p>
                </td>
                <td>
                    <p>These cookies are used to help us monitor how the product is performing, allowing us to improve and tailor the user experience.</p>
                </td>
            </tr>
            }
        </table>
    </div>
</div>
